import React, { Component } from 'react';
import { FaTimes } from "react-icons/fa";
import {
    WidgetConnContainer,
    WidgetConnHeader, WidgetConnTitle,
    WidgetConnController, WidgetConnBody,
    WidgetConnInformation, WidgetConnMessage, WidgetConnLabel,
    RowButton, Button, ButtonText,
    ControllerBtnIconLarge, ControllerBtnIcon
} from "../component/Component.Connection";


class WidgetConnection extends Component {
    constructor(props){
        super(props);
        this.closeComponent     = this.props.closeComponent;
        this.optionButtonTrue   = this.props.optionButtonTrue || undefined;

        this.msgHeader      = props.header || 'Notifications';
        this.msgTitle       = props.title;
        this.msgDetail      = props.message;        
        this.msgType        = props.type || '';
        
        switch(this.msgType.toString().trim().toLowerCase()){
            case 'warning':
                this.widgetType     = 'warning';
            break;
            case 'error':
                this.widgetType     = 'error';
            break;
            case 'information':
                this.widgetType     = 'information';
            break;
            case 'message':
                this.widgetType     = 'primary';
            break;
            default:
                this.widgetType     = 'normal';
        }

        this.state = {
            buttonOption: props.isButtonOption || false,
            messageHeader: props.header || 'Notifications',
            messageTitle: props.title || '',
            messageDetail: props.message || '',
            messageType: this.widgetType,
            labelButtonTrue: props.labelButtonTrue || 'Yes',
        }

        this.handleCloseWidget          = this.handleCloseWidget.bind(this);
        this.handleButtonTrueClicked    = this.handleButtonTrueClicked.bind(this);
    }

    componentDidMount(){
        if (this.state.buttonOption && typeof this.optionButtonTrue === 'function'){
            if (document.getElementById('widget-info-button-true') !== null){
                document.getElementById('widget-info-button-true').focus();
            }
        }
    }

    handleCloseWidget(e){
        e.preventDefault();
        this.closeComponent();
    }

    handleButtonTrueClicked(e){
        e.preventDefault();
        if (typeof this.optionButtonTrue === 'function'){
            this.optionButtonTrue();
        }
    }

    render(){
        return (
            <WidgetConnContainer Mode={this.widgetType}>
                <WidgetConnHeader Mode={this.widgetType}>
                    <WidgetConnTitle>{this.state.messageHeader}</WidgetConnTitle>
                    <WidgetConnController IsBtnClose onClick={(e) => {this.handleCloseWidget(e);}}>
                        <ControllerBtnIconLarge><FaTimes size={22} /></ControllerBtnIconLarge>
                        <ControllerBtnIcon><FaTimes size={22} /></ControllerBtnIcon>
                    </WidgetConnController>
                </WidgetConnHeader>
                <WidgetConnBody>
                    <WidgetConnInformation MarginTop={5} IsBold IsUpperCase Mode={this.widgetType}>
                        {this.state.messageTitle}
                    </WidgetConnInformation>
                    <WidgetConnMessage MarginTop={5}>
                        <WidgetConnLabel>{this.state.messageDetail}</WidgetConnLabel>
                    </WidgetConnMessage>
                    {this.state.buttonOption && typeof this.optionButtonTrue === 'function'?
                    <RowButton MarginTop={10}>
                        <Button Mode={'primary'} onClick={(e) => {this.handleButtonTrueClicked(e);}}>
                            <ButtonText>{this.state.labelButtonTrue}</ButtonText>
                        </Button>
                    </RowButton>
                    :null}
                </WidgetConnBody>
            </WidgetConnContainer>
        )
    }
}

export default WidgetConnection;